import React, { useState, useEffect } from 'react';

const Keuangan = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulasi fetch data dari API
    setTimeout(() => {
      setData({
        saldo: 125000000,
        pemasukan: [
          { id: 1, tanggal: '2024-01-15', sumber: 'Penjualan Produk', jumlah: 5000000 },
          { id: 2, tanggal: '2024-01-10', sumber: 'Jasa Sewa', jumlah: 3000000 },
          { id: 3, tanggal: '2024-01-05', sumber: 'Investasi', jumlah: 2000000 }
        ],
        pengeluaran: [
          { id: 1, tanggal: '2024-01-12', keterangan: 'Bahan Baku', jumlah: 2500000 },
          { id: 2, tanggal: '2024-01-08', keterangan: 'Operasional', jumlah: 1500000 },
          { id: 3, tanggal: '2024-01-03', keterangan: 'Pemeliharaan', jumlah: 1000000 }
        ]
      });
      setLoading(false);
    }, 1000);
  }, []);

  const formatRupiah = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  const totalPemasukan = data.pemasukan.reduce((sum, item) => sum + item.jumlah, 0);
  const totalPengeluaran = data.pengeluaran.reduce((sum, item) => sum + item.jumlah, 0);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Manajemen Keuangan</h1>
          <p className="text-gray-600">Kelola pemasukan dan pengeluaran BUMDES</p>
        </div>
        <div className="flex space-x-3">
          <button className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center">
            <span className="mr-2">+</span> Pemasukan
          </button>
          <button className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center">
            <span className="mr-2">-</span> Pengeluaran
          </button>
        </div>
      </div>

      {/* Saldo Card */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex justify-between items-start">
          <div>
            <h2 className="text-lg font-semibold">Saldo BUMDES</h2>
            <p className="text-3xl font-bold mt-2">{formatRupiah(data.saldo)}</p>
            <p className="text-blue-100 mt-1">Update terakhir: {new Date().toLocaleDateString('id-ID')}</p>
          </div>
          <div className="bg-white bg-opacity-20 p-4 rounded-xl">
            <span className="text-3xl">💰</span>
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-4 mt-6">
          <div className="bg-white bg-opacity-20 rounded-lg p-3">
            <p className="text-sm opacity-90">Total Pemasukan</p>
            <p className="text-lg font-semibold">+{formatRupiah(totalPemasukan)}</p>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg p-3">
            <p className="text-sm opacity-90">Total Pengeluaran</p>
            <p className="text-lg font-semibold">-{formatRupiah(totalPengeluaran)}</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Pemasukan */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold text-gray-900">Pemasukan</h3>
            <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
              + {formatRupiah(totalPemasukan)}
            </span>
          </div>
          <div className="space-y-4">
            {data.pemasukan.map((item) => (
              <div key={item.id} className="flex items-center justify-between p-4 border border-gray-100 rounded-lg hover:border-green-200 hover:bg-green-50 transition-colors">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center text-green-600 mr-3">
                    📥
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{item.sumber}</p>
                    <p className="text-sm text-gray-500">{formatDate(item.tanggal)}</p>
                  </div>
                </div>
                <span className="text-green-600 font-semibold">
                  +{formatRupiah(item.jumlah)}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Pengeluaran */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold text-gray-900">Pengeluaran</h3>
            <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium">
              - {formatRupiah(totalPengeluaran)}
            </span>
          </div>
          <div className="space-y-4">
            {data.pengeluaran.map((item) => (
              <div key={item.id} className="flex items-center justify-between p-4 border border-gray-100 rounded-lg hover:border-red-200 hover:bg-red-50 transition-colors">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center text-red-600 mr-3">
                    📤
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{item.keterangan}</p>
                    <p className="text-sm text-gray-500">{formatDate(item.tanggal)}</p>
                  </div>
                </div>
                <span className="text-red-600 font-semibold">
                  -{formatRupiah(item.jumlah)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Grafik Ringkas */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Grafik Keuangan Bulan Ini</h3>
        <div className="h-64 bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl flex items-center justify-center text-gray-500 border-2 border-dashed border-gray-300">
          <div className="text-center">
            <div className="text-4xl mb-2">📈</div>
            <p>Grafik keuangan akan ditampilkan di sini</p>
            <p className="text-sm">Integrasi dengan chart library</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Keuangan;